import angular from 'angular';
import { GaugeModule } from '@updater/angular-common';

import { AccordionModule } from '../common/directives/accordion';
import { AlertModule } from '../common/directives/alert';
import { ArrowBoxModule } from '../common/directives/arrow-box';
import { EllipsisModule } from '../common/directives/ellipsis';
import { HomeServicesContentModule } from '../steps/home-services/content';
import { LayoutModule } from '../common/directives/layout';
import { MatchMediaModule } from '../common/directives/match-media';
import { PopupModule } from '../common/directives/popup';
import { StickyModule } from '../common/directives/sticky';
import TitleizeFilterModule from '../common/filters/titleize';

import DashboardConfig from './dashboard.config';

import { DashboardComponent } from './dashboard.component';
import { DashboardSubheaderComponent } from './subheader';
import { LocationHeroComponent } from './location-hero';
import { MoveDatepickerComponent } from './subheader/move-datepicker';
import { MoveWhenWhereComponent } from './subheader/move-when-where';
import { PhaseNavComponent } from './subheader/phase-nav';
import { MessageCenterComponent } from './message-center';
import { TimelineComponent, timelineWeaveLayout } from './timeline';
import { TimelineItemComponent } from './timeline/item';
import { TimelineStepComponent } from './timeline/step/step.component';
import { TimelineStepStatusComponent } from './timeline/step-status';
import { TimelineTransformCopyFilter } from './timeline/transform-copy.filter';

import { PhasesTimelineComponent } from './phases-timeline';

export const DashboardModule = angular
  .module('app.dashboard', [
    AccordionModule.name,
    AlertModule.name,
    ArrowBoxModule.name,
    EllipsisModule.name,
    StickyModule.name,
    GaugeModule.name,
    HomeServicesContentModule.name,
    LayoutModule.name,
    MatchMediaModule.name,
    PopupModule.name,
    TitleizeFilterModule.name,
  ])
  .config(DashboardConfig)
  .config(updLayoutsProvider => {
    updLayoutsProvider.register('timelineWeave', timelineWeaveLayout);
  })
  .component('updDashboard', DashboardComponent)
  .component('updDashboardSubheader', DashboardSubheaderComponent)
  .component('updLocationHero', LocationHeroComponent)
  .component('updMoveDatepicker', MoveDatepickerComponent)
  .component('updMoveWhenWhere', MoveWhenWhereComponent)
  .component('updPhaseNav', PhaseNavComponent)
  .component('updMessageCenter', MessageCenterComponent)
  .component('updTimeline', TimelineComponent)
  .component('updTimelineItem', TimelineItemComponent)
  .component('updTimelineStep', TimelineStepComponent)
  .component('updTimelineStepStatus', TimelineStepStatusComponent)
  .filter('updTimelineTransformCopy', () => TimelineTransformCopyFilter)
  .component('updPhasesTimeline', PhasesTimelineComponent);
